import { z } from 'zod';
import type { UrlRedirectToken } from '@sleed/bizcommerce-api';

/** URL redirect (301) edit form — legacy grid: urlf/urlt required ≤400. mdt/uduid are server metadata. */
export const urlRedirectSchema = z.object({
	id: z.number().optional(),
	urlf: z.string().trim().min(1, 'validation.required').max(400, 'validation.tooLong'),
	urlt: z.string().trim().min(1, 'validation.required').max(400, 'validation.tooLong'),
	mdt: z.string().nullable(),
	uduid: z.number().nullable()
});

export type UrlRedirectFormValues = z.infer<typeof urlRedirectSchema>;

export const EMPTY_URL_REDIRECT: UrlRedirectFormValues = { urlf: '', urlt: '', mdt: null, uduid: null };

export function tokenToForm(token: UrlRedirectToken): UrlRedirectFormValues {
	return {
		id: token.id,
		urlf: token.urlf ?? '',
		urlt: token.urlt ?? '',
		mdt: token.mdt ? String(token.mdt) : null,
		uduid: token.uduid ?? null
	};
}

export function formToToken(form: UrlRedirectFormValues): UrlRedirectToken {
	return { id: form.id, urlf: form.urlf.trim(), urlt: form.urlt.trim(), mdt: form.mdt, uduid: form.uduid };
}
